import { useEffect, useState } from 'react';
import { NavLink, Route, Routes } from 'react-router-dom';
import { useLive } from './hooks/useLive';
import { Dashboard } from './pages/Dashboard';
import { DeviceDetail } from './pages/DeviceDetail';
import { Gateways } from './pages/Gateways';

type Theme = 'auto' | 'light' | 'dark';

export function App() {
  const { connected } = useLive();
  const [theme, setTheme] = useState<Theme>(
    () => (localStorage.getItem('theme') as Theme | null) ?? 'auto',
  );

  useEffect(() => {
    // `auto` toglie l'attributo e lascia decidere a prefers-color-scheme.
    if (theme === 'auto') document.documentElement.removeAttribute('data-theme');
    else document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  return (
    <div className="app">
      <header className="topbar">
        <h1>Irrigazione</h1>
        <nav>
          <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : '')}>
            Irrigatori
          </NavLink>
          <NavLink to="/gateways" className={({ isActive }) => (isActive ? 'active' : '')}>
            Gateway
          </NavLink>
        </nav>
        <span className="spacer" />
        <span className="tiny muted" title={connected ? 'Aggiornamenti in tempo reale attivi' : 'Riconnessione in corso'}>
          {connected ? 'live' : 'offline'}
        </span>
        <button
          className="btn btn--sm"
          onClick={() => setTheme(theme === 'auto' ? 'light' : theme === 'light' ? 'dark' : 'auto')}
          title="Cambia tema"
        >
          {theme === 'auto' ? 'Auto' : theme === 'light' ? 'Chiaro' : 'Scuro'}
        </button>
      </header>

      <main className="content">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/devices/:id" element={<DeviceDetail />} />
          <Route path="/gateways" element={<Gateways />} />
          <Route path="*" element={<p className="muted">Pagina non trovata.</p>} />
        </Routes>
      </main>
    </div>
  );
}
